import { render, staticRenderFns } from "./UserEvaluationComponent_v2.vue?vue&type=template&id=1ffd530c&scoped=true&"
import script from "./UserEvaluationComponent_v2.vue?vue&type=script&lang=js&"
export * from "./UserEvaluationComponent_v2.vue?vue&type=script&lang=js&"
import style0 from "./UserEvaluationComponent_v2.vue?vue&type=style&index=0&id=1ffd530c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd530c",
  null
  
)

export default component.exports